import React from 'react';
import Card from '../../components/common/Card/Card';
import DocumentUpload from '../../components/documents/DocumentUpload/DocumentUpload';
import DocumentList from '../../components/documents/DocumentList/DocumentList';
import SearchResults from '../../components/documents/SearchResults/SearchResults';
import './Documents.css';

const Documents = () => {
  return (
    <div className="documents-page">
      <div className="documents-header">
        <h1 className="documents-title">Document Management</h1>
        <p className="documents-subtitle">
          Upload, manage, and search through your financial documents
        </p>
      </div>

      <div className="documents-content">
        <div className="documents-main">
          <Card title="Document Library" className="library-card">
            <DocumentList />
          </Card>
        </div>

        <div className="documents-sidebar">
          <Card title="Search Results" className="search-card">
            <SearchResults />
          </Card>
          <Card title="Upload Documents" className="upload-card">
            <DocumentUpload />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Documents; 